<template>
  <div>
    <!-- main page -->
    <div class="vx-row">
      <div class="vx-col py-2" v-if="checkAll.length <= 0">
        <vs-button class="m-2" v-on:click="SubmitApproval()" color="primary"
          >Submit</vs-button
        >
      </div>
      <div v-else class="vx-col py-2">
        <div class="vx-row">
          <div class="vx-col py-2">
            <vs-button class="m-2" v-on:click="checkAllAccept = true, typeReqCheckAll = 'approve'" color="primary"
              >Approve</vs-button
            >
            <vs-button class="m-2" v-on:click="checkAllAccept = true, typeReqCheckAll = 'reject'" color="danger"
              >Reject</vs-button
            >
            <vs-button class="m-2" v-on:click="checkAllAccept = true, typeReqCheckAll = 'inquiry'" color="warning"
              >Inquiry</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row mb-12">
      <div class="vx-col sm:w-1/1 w-full mb-base">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{
                    this.dataEnd == 0
                      ? 0
                      : this.limitShow * (this.isActive - 1) + 1
                  }}
                  - {{ this.limitShow * (this.isActive - 1) + dataEnd }} of
                  {{ this.recordsTotal }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="item in limits"
                  v-bind:key="item"
                  @click="changeLimit(item)"
                >
                  <span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <div class="mx-auto"></div>
          <div class="vx-col sm:w-1/3 w-full">
            <div class="flex flex-wrap items-center justify-between">
              <vs-input
                class="mb-4 md:mb-0 mr-4 w-full"
                v-model="search"
                placeholder="Search by SO Code, Customer Code, and Customer Name"
              />
            </div>
          </div>
        </div>

        <vs-table :data="dataSalesOrder" stripe border>
          <template slot="thead">
            <vs-th width="50px">
                <vs-checkbox
                  :class="{ 'is-indeterminate': isIndeterminate }"
                  :disabled="disabledCheck"
                  v-model="isCheckAll"
                    v-on:click="checkApproval('','all',null,0)"
                    >
                    <!-- {{ checkAll.length>0?recordsTotal-unCheckAll.length+" Selected":""}} -->
                </vs-checkbox>
            </vs-th>
            <vs-th> Action </vs-th>
            <vs-th> Sales Order </vs-th>
            <vs-th> Customer </vs-th>
            <vs-th> Company </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indexSO" v-for="(dt, indexSO) in data">
              <vs-td v-show="checkAll.length > 0" class="text-left">
                <vs-checkbox
                  :checked="checkAll.includes(dt.Code)"
                  :disabled="disabledCheck"
                  v-on:click="checkApproval(dt.Code, 'check', dt, indexSO)
                  "
                  />
              </vs-td>
              <vs-td :colspan="checkAll.length > 0?0:2">
                <div class="vx-row" style="align-items: center">
                  <div class="vx-col py-2">
                    <vs-checkbox
                      :checked="approved.includes(dt.Code)"
                      :disabled="checkAll.length > 0"
                      v-on:click="
                        checkApproval(dt.Code, 'approve', dt, indexSO)
                      "
                      >Approve</vs-checkbox
                    >
                  </div>
                  <div class="vx-col py-2">
                    <vs-checkbox
                      class="vs-checkbox-danger"
                      :disabled="checkAll.length > 0"
                      :checked="rejected.includes(dt.Code)"
                      v-on:click="checkApproval(dt.Code, 'reject', dt, indexSO)"
                      >Reject</vs-checkbox
                    >
                  </div>
                  <div class="vx-col py-2">
                    <vs-checkbox
                      class="vs-checkbox-warning"
                      :checked="inquiry.includes(dt.Code)"
                      :disabled="checkAll.length > 0"
                      v-on:click="checkApproval(dt.Code, 'inquiry', dt, indexSO)"
                      >Inquiry</vs-checkbox
                    >
                  </div>
                  <div class="vx-col py-2">
                    <vs-select label="Select Reason" 
                      v-model="data[indexSO].ApprovalRemark" :disabled="checkAll.length > 0" 
                      @input-change="updateRemark(dt.Code, $event, dt, indexSO)">
                      <vs-select-item
                        :key="index"
                        :value="item.reason"
                        :text="item.reason"
                        v-for="(item, index) in reasonOptions"
                      />
                    </vs-select>
                  <!-- <multiselect
                    v-show="dt.ShowReasonSelect"
                    v-model="dt.ApprovalRemark"
                    :options="reasonOptions"
                    placeholder="Type to search"
                    label="reason"
                    track-by="ID"
                    :showNoOptions="false"
                    :max-height="125"
                    @select="updateRemark(dt.Code, $event, dt, indexSO)"
                  >
                    <span slot="noResult">Oops! No data found</span>
                  </multiselect> -->
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <vs-button
                  size="[detail ? 'small' : '', '']"
                  v-on:click="clickSOCode(dt)"
                  color="primary"
                  type="gradient"
                >
                  {{ dt.Code }}
                </vs-button>
                <br /><br />
                SO Date : {{ dateFormat(dt.Date) }} <br />
                PO Ref. Code :
                {{ dt.PoReferenceCode ? dt.PoReferenceCode : "-" }} <br />
                Source : {{ dt.Source }} <br />
                Sales : <b>{{ dt.SalesPersonalName }}</b> <br />
                Channel : ({{ dt.SalesChannel.Code }})
                {{ dt.SalesChannel.Name }} <br />
                Delivery Type :
                <span v-if="dt.DeliveryTypeID != 0 && dt.DeliveryType">
                  ({{ dt.DeliveryType.Code }}) {{ dt.DeliveryType.Name }} </span
                ><span v-if="dt.DeliveryTypeID == 0">-</span><br />
                Delivery Date : {{ dateFormat(dt.DueDate) }} <br />
                Total : <b>{{ "Rp. "+formatCurrency(dt.Total) }}</b>
                <span
                  v-if="dt.Total > dt.Customer.CustomerLimit.Balance"
                  style="color: red"
                  >(exceeds customer limit :
                  {{
                    customerLimitPercentage(dt.Total, dt.Customer.CustomerLimit.Balance)
                  }}% )</span
                >
                <br />
                Total Line : {{ dt.CountSoItem }} <br />
                Notes : {{ dt.Notes }}<br />
                Outstanding :
                <span style="color: red"
                  ><b>{{ "Rp. "+formatCurrency(dt.Customer.Outstanding) }}</b></span
                >
              </vs-td>
              <vs-td>
                Channel : {{ dt.Customer.CustomerCategory.Name }} <br />
                Code : {{ dt.Customer.Code }} <br />
                Name : {{ dt.Customer.Name }} <br />
                Bill to : {{ dt.BillAddress.Code }} - {{ dt.BillAddress.ContactName }}<br />
                Ship to : {{ dt.ShipAddress.Code }} - {{ dt.ShipAddress.ContactName }}<br />
                Payment term : {{ dt.PaymentTerm.Name }} <br />
                Limit : <b>{{ "Rp. "+ formatCurrency(dt.Customer.CustomerLimit.Balance) }}</b>
              </vs-td>
              <vs-td>
                Code : {{ dt.Customer.Company.Code }} <br />
                Name : {{ dt.Customer.Company.Name }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <vs-pagination
          style="padding-top: 5px"
          :total="maxPage"
          v-model="currentPage"
          :prev-icon="$vs.rtl ? 'arrow_forward' : 'arrow_back'"
          :next-icon="$vs.rtl ? 'arrow_back' : 'arrow_forward'"
        />
      </div>
    </div>
    <vs-popup fullscreen title="Sales Order Lines" :active.sync="detail">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <detailSelectedSo v-show="detail" :selectedSO="selectedSO"></detailSelectedSo>
        </div>
      </div>
    </vs-popup>

    <vs-prompt
      @cancel="typeReqCheckAll='',checkAllRemark=null,checkAllRemarkValid = true"
      @close="typeReqCheckAll= '',checkAllRemark=null,checkAllRemarkValid = true"
      @accept="SubmitApproval(typeReqCheckAll)"
      :active.sync="checkAllAccept"
      :title="'Confirm '+typeReqCheckAll+' of '+countCheckAll+' records'"
      :is-valid="checkAllRemarkValid"
      accept-text="accept"
    >
      <div class="con-exemple-prompt">
        <div>
        <label for class="vs-input--label">Select Reason</label>
          <multiselect
              class="selectExample"
              v-model="checkAllRemark"
              :options="reasonOptions"
              :multiple="false"
              :allow-empty="false"
              :group-select="false"
              :max-height="200"
              :select-label="''"
              :deselect-label="''"
              @select="checkAllRemarkValid = true"
              placeholder="Type to search"
          >
              <template slot="singleLabel" slot-scope="props">
                  <span class="option__desc">
                      <span class="option__title">{{ props.option.reason }}</span>
                  </span>
              </template>
              <template slot="option" slot-scope="props">
                  <div class="option__desc">
                      <span class="option__title">{{ props.option.reason }}</span>
                  </div>
              </template>
          </multiselect>
        </div>
        <vs-alert
          :active="!(checkAllRemark !=null || checkAllRemarkValid)"
          color="danger"
          icon="new_releases"
        >
          Fields can not be empty please enter the data
        </vs-alert>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import detailSelectedSo from "./detail_selected_so.vue";
import moment from "moment";
import dataApprovalNewSO from "@/assets/data_dummy/approval/sales_order/sales_order_new_so.json"

export default {
  components: {
    detailSelectedSo,
  },
  mounted() {
    this.dataSalesOrder = [];
    this.selectedSO = this.dataSalesOrder;
    this.getReasonOptions();
    // this.setDummySalesOrders();
  },
  props: ["territory", "startDate", "endDate", "filter","so_numbers_str"],
  data() {
    return {
      isCheckAll:false,
      reasonOptions: [],
      checkAllAccept:false,
      typeReqCheckAll:"",
      selectedSO: {},
      disabledCheck:false,
      checkAllRemarkValid:true,
      dataSalesOrder: [
        {
          SalesOrderLine: [{}],
          Customer: {
            Code: "",
            Name: "",
            Address: "",
            Phone: "",
            CustomerCategory: {
              Name: "",
            },
          },
          CustomerLimit: {
            Balance: 0,
          },
          Company: {
            Code: "",
            Name: "",
          },
          SalesChannel: {
            Code: "",
            Name: "",
          },
          BillAddress: {
            Address: "",
            City: "",
            Country: "",
          },
          ShipAddress: {
            Address: "",
            City: "",
            Country: "",
          },
          Salesman: {
            Name: "",
          },
          PaymentTerm: {
            Name: "",
          },
        },
      ],
      salesOrderCode: "",

      approved: [],
      approveAll: false,
      rejected: [],
      rejectAll: false,
      inquiry: [],
      checkAll: [],
      countCheckAll:0,
      unCheckAll: [],
      checkAllRemark:null,
      inquiryAll: false,
      remark: [],
      remarkCode: [],
      limitCheckAll:100,

      limits: [10, 25, 50, 100, "All"],
      limitShow: 10,
      drawData: 0,
      isActive: 1,
      modelCheck: [],
      search: "",
      detailShow: "core vx-col md:w-1/2 w-full mb-base ",
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      detail: false,
      recordsTotal: 0,
      maxPage: 2,
      dataEnd: 0,
    };
  },
  watch: {
    filter: function (v) {
      if (v>0) {
        console.log("count filter", v);
        this.checkAll = []
        this.inquiry = [];
        this.approved = [];
        this.rejected = [];
        this.isCheckAll = false;
        this.getData();
      }
    },
    search: function () {
      this.checkAll = []
      this.inquiry = [];
      this.approved = [];
      this.rejected = [];
      this.isCheckAll = false;
      this.getData();
    },
    // startDate: function () {
    //   this.getData();
    // },
    // endDate: function () {
    //   this.getData();
    // },
  },
  computed: {
    isIndeterminate() {
      return this.countCheckAll!=0 && this.countCheckAll < (this.limitCheckAll > this.dataEnd ? this.dataEnd:this.limitCheckAll)
    },
    currentPage: {
      get() {
        return 1;
      },
      set(page) {
        this.page(page);
      },
    },
  },
  methods: {
    async getReasonOptions() {
      let params = {
        reason_group: "Reject SO",
      };
      let resp = await this.$http.get("/api/v1/reasons", { params });

      if (resp.code == 200) {
        this.reasonOptions = resp.data.records;
      } else {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: resp.message,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
      }
    },
    customerLimitPercentage(order, balance) {
      let result = ((order - balance) / balance) * 100;
      return result.toFixed(2);
    },

    dateFormat(date) {
      if (date) {
        return moment(String(date)).utcOffset(0).format("DD/MM/YYYY hh:mm");
      }
    },

    formatCurrency(nominal) {
      if (nominal) {
        return nominal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        return 0;
      }
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    getSOLine() {
      const search = this.salesOrderCode;
      if (search) {
        this.selectedSO = this.dataSalesOrder.filter(
          (so) => so.Code.indexOf(search) > -1
        )[0]; // filter + get 1st record
      }
    },
    getSOLineV2(id) {
      this.$vs.loading();
      this.$http
      .get("/api/v1/sales-order-mix2", {
        params: {
          sales_order_id: id,
        },
      }).then((resp) => {
        this.$vs.loading.close();
        if (resp.code == 200) {
            this.detail = true;
            this.selectedSO = resp.data.SalesOrders[0];
            console.log("this.selectedSO v1=>",this.selectedSO)
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        }).catch((error) => {
          console.log("get line error",error);
          this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Failed to fetch sales order line data",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          this.$vs.loading.close();
        });
    },

    clickSOCode(dt) {
      this.closeDetail();
      setTimeout(function () {}, 3000);
      this.salesOrderCode = dt.Code;
      this.getSOLineV2(dt.ID);
      // this.scrollToTop();
    },

    closeDetail() {
      this.detail = false;
    },

    checkApproval(soCode, action, dt, indexSO) {
      this.disabledCheck = true
      if (action == "approve") {
        if (this.approved.includes(soCode)) {
          this.approved.splice(this.approved.indexOf(soCode), 1); // unchecked approve
        } else {
          this.dataSalesOrder[indexSO].ShowReasonSelect = false;
          this.approved.push(soCode); // checked approve
          this.rejected = this.rejected.filter((value) => value !== soCode); // unchecked reject
          this.inquiry = this.inquiry.filter((value) => value !== soCode); // unchecked inquiry
        }
      } else if (action == "reject") {
        if (this.rejected.includes(soCode)) {
          this.dataSalesOrder[indexSO].ShowReasonSelect = false;
          this.rejected.splice(this.rejected.indexOf(soCode), 1); // unchecked reject
        } else {
          this.dataSalesOrder[indexSO].ShowReasonSelect = true;
          this.rejected.push(soCode); // checked reject
          this.approved = this.approved.filter((value) => value !== soCode); // unchecked approve
          this.inquiry = this.inquiry.filter((value) => value !== soCode); // unchecked inquiry
        }
      } else if (action == "inquiry") {
        if (this.inquiry.includes(soCode)) {
          this.dataSalesOrder[indexSO].ShowReasonSelect = false;
          this.inquiry.splice(this.inquiry.indexOf(soCode), 1); // unchecked inquiry
        } else {
          this.dataSalesOrder[indexSO].ShowReasonSelect = true;
          this.inquiry.push(soCode); // checked inquiry
          this.approved = this.approved.filter((value) => value !== soCode); // unchecked approve
          this.rejected = this.rejected.filter((value) => value !== soCode); // unchecked reject
        }
      }else if (action == "all"){
        console.log("checkall");
        var countCheck = 0;
        if (!this.isCheckAll) {
          this.checkAll = [];
          this.unCheckAll =[];
          // this.countCheckAll = this.limitCheckAll > this.recordsTotal ? this.recordsTotal:this.limitCheckAll;
          this.dataSalesOrder.forEach((so)=>{
            if (countCheck<this.limitCheckAll) {
              this.checkAll.push(so.Code);
              countCheck++;
            }
          })
          this.countCheckAll = countCheck;
        }else{
          this.checkAll = [];
        }
        this.inquiry = [];
        this.approved = [];
        this.rejected = [];
      }else if (action == "check"){
        if (this.checkAll.includes(soCode)) {
          this.checkAll = this.checkAll.filter((value) => value !== soCode);
          this.unCheckAll.push(soCode);
          this.isCheckAll = false;
          this.countCheckAll--;
        }else{
          this.countCheckAll++;
          this.checkAll.push(soCode);
          // var countUncheck =this.unCheckAll.length
          // if (this.unCheckAll.includes(soCode)) {
          //   countUncheck--
          // }
          if (this.countCheckAll > this.limitCheckAll) {
            setTimeout(() => {
              this.countCheckAll--
              console.log("[2] this.countCheckAll",this.countCheckAll)
              this.checkAll = this.checkAll.filter((value) => value !== soCode);
            }, 200);
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: `Maximum of ${this.limitCheckAll} selections allowed`,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }else if (this.unCheckAll.includes(soCode)){
            this.unCheckAll = this.unCheckAll.filter((value) => value !== soCode);
          }
          this.isCheckAll =  this.countCheckAll >= (this.limitCheckAll > this.dataEnd ? this.dataEnd:this.limitCheckAll);
        }
        console.log("this.countCheckAll",this.countCheckAll)
        console.log("this.checkAll",this.checkAll);
        console.log("this.unCheckAll",this.unCheckAll);
      }
      setTimeout(() => {
        this.disabledCheck = false
      }, 200);
    },

    checkAllApproval(action) {
      if (action == "approve") {
        this.rejectAll = false;
        if (this.approveAll == false) {
          for (var i = 0; i < this.dataSalesOrder.length; i++) {
            if (this.approved.includes(this.dataSalesOrder[i].Code)) {
              //
            } else {
              this.approved.push(this.dataSalesOrder[i].Code);
              this.rejected.splice(this.approved.indexOf(i), 1); // unchecked reject
            }
          }
        } else {
          for (var j = 0; j < this.dataSalesOrder.length; j++) {
            this.approved.splice(
              this.approved.indexOf(this.dataSalesOrder[j].id),
              1
            );
          }
        }
      } else if (action == "reject") {
        this.approveAll = false;
        if (this.rejectAll == false) {
          for (var k = 0; k < this.dataSalesOrder.length; k++) {
            if (this.rejected.includes(this.dataSalesOrder[k].Code)) {
              //
            } else {
              this.rejected.push(this.dataSalesOrder[k].Code);
              this.approved.splice(this.rejected.indexOf(k), 1); // unchecked approve
            }
          }
        } else {
          for (var l = 0; l < this.dataSalesOrder.length; l++) {
            this.rejected.splice(
              this.rejected.indexOf(this.dataSalesOrder[l].id),
              1
            );
          }
        }
      }
    },

    updateRemark(SOCode, $event, dt, indexSO) {
      // change dt.ApprovalRemark to $event.reason
      this.dataSalesOrder[indexSO].ApprovalRemark = $event.reason;

      if (this.remarkCode.includes(SOCode)) {
        const idx = this.remarkCode.indexOf(SOCode);
        this.remark.splice(idx, 0, event.reason);
      } else {
        this.remarkCode.push(SOCode);
        this.remark.push(event.reason);
      }
    },

    page(page) {
      if (this.filter>0){
        this.checkAll = []
        this.inquiry = [];
        this.approved = [];
        this.rejected = [];
        this.isCheckAll = false;
        this.getData(page);
      }
      return page;
    },

    changeLimit(limit) {
      if (limit == "All") {
          limit = -1;
      }
      this.limitShow = limit;
      this.getData(this.isActive);
    },

    getData(page = 1) {
      this.checkAll = [];
      this.unCheckAll = [];
      this.countCheckAll = 0;
      // this.isCheckAll = false
      this.typeReqCheckAll = ""
      if (typeof this.territory == "undefined") {
        return true;
      }
      var pass = false
      if (pass) {
        return
      }
      this.isActive = page;
      this.$vs.loading();
      console.log("this.so_numbers_str",this.so_numbers_str)
      this.$http
        .get("/api/v1/sales-order-mix2", {
          params: {
            territory_codes: this.territory,
            sales_order_numbers:this.so_numbers_str,
            start_date: this.startDate,
            end_date: this.endDate,
            approval_status: 0,
            approval_manager: 3,
            validation_status: 2,
            allocation_status: 0,
            search: this.search,
            limit: this.limitShow,
            offset: this.limitShow * (page - 1),
            order: "desc",
            is_use_approval_matrix: true,
            progress_restriction: true,
            progress_status: "waiting_approval",
          },
        })
        .then((resp) => {
          // console.log(resp.data);
          if (resp.code == 200) {
            this.drawData = this.drawData + 1;
            this.dataSalesOrder = resp.data.SalesOrders;
            // add default false showReasonSelect
            this.dataSalesOrder.forEach((element) => {
              element.ApprovalRemark = "";
              element.ShowReasonSelect = false;
              if (this.isCheckAll&&!this.unCheckAll.includes(element.Code)) {
                this.checkAll.push(element.Code)
                this.countCheckAll++;
              }
            });
            this.recordsTotal = resp.data.RecordsTotal;
            this.maxPage = Math.ceil(this.recordsTotal / this.limitShow);
            this.dataEnd = resp.data.ResultsTotal;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
          this.$vs.loading.close();
        });
    },

    SubmitApproval(typeRequest ="") {
      //typeRequest => approve, reject, inquiry
      // const formData = new FormData();
      // formData.set('approved_sales_order_codes', this.approved);
      // formData.set('rejected_sales_order_codes', this.rejected);
      // var json_form = JSON.stringify(Object.fromEntries(formData));
      // console.log(json_form);

      // let temp_remark = [];
      // for (let index = 0; index < this.remarkCode.length; index++) {
      //     const code = this.remarkCode[index];
      //     temp_remark[code] = this.remark[index];
      // }
      this.dataSalesOrder.forEach((dt) => {
        if (
          !this.checkAllRemark && dt.ApprovalRemark && dt.ApprovalRemark != ""
        ) {
          switch (true) {
            case this.approved.includes(dt.Code):
                this.remarkCode.push(dt.Code);
                this.remark.push(dt.ApprovalRemark);
              break;
            case this.rejected.includes(dt.Code):
                this.remarkCode.push(dt.Code);
                this.remark.push(dt.ApprovalRemark);
              break 
            case this.inquiry.includes(dt.Code):
                this.remarkCode.push(dt.Code);
                this.remark.push(dt.ApprovalRemark);
              break;
            default:
              break;
          }
        }
      });
      var payload ={
          approved_sales_order_codes: this.approved,
          rejected_sales_order_codes: this.rejected,
          inquiry_sales_order_codes: this.inquiry,
          check_all_sales_order_codes: this.checkAll,
          uncheck_all_sales_order_codes: this.unCheckAll,
          type_request:typeRequest,
          is_check_all:this.isCheckAll, 
          type: "release",
          remarks: this.remark,
          remark_codes: this.remarkCode,
        };

        if (this.countCheckAll > 0) {
          if (this.checkAllRemark == null ||(this.checkAllRemark != null && this.checkAllRemark.reason == "")) {
            if (typeRequest =="reject"||typeRequest =="inquiry") {
              this.checkAllAccept = true
              this.checkAllRemarkValid = false
              return
            }
          }
          payload.type_request = typeRequest;
          payload.is_check_all = this.checkAll.length > 0 || this.isCheckAll || typeRequest != "";
          payload.uncheck_all_sales_order_codes = this.unCheckAll;
          payload.check_all_sales_order_codes = this.checkAll;
          if (this.checkAllRemark) {
            payload.remark = this.checkAllRemark.reason
          }

          payload.territory_codes = this.territory;
          payload.sales_order_numbers = this.so_numbers_str;
          payload.start_date = this.startDate;
          payload.end_date = this.endDate;
          payload.approval_status = 0;
          payload.approval_manager = 3;
          payload.validation_status = 2;
          payload.allocation_status = 0;
          payload.order = "desc";
          payload.is_use_approval_matrix = true;
        }
      this.$vs.loading();
      this.$http
        .post("/api/v1/sales-order/approval-by-code", payload)
        .then((resp) => {
          if (resp.code == 200) {
            this.$vs.notify({
              title: "Success",
              text: "",
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });

            // reset selected
            this.approved = []
            this.approveAll = false
            this.rejected = []
            this.rejectAll = false
            this.inquiry = []
            this.inquiryAll = false
            this.remark = []
            this.remarkCode = []

            this.checkAll = [];
            this.unCheckAll = [];
            this.countCheckAll = 0;
            this.isCheckAll = false
            this.typeReqCheckAll = ""

            this.getData();
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
          this.$vs.loading.close();
        });
        this.typeReqCheckAll = ""
        this.checkAllRemark = null
    },
    setDummySalesOrders(){
      this.recordsTotal = dataApprovalNewSO.length;
      this.maxPage = Math.ceil(this.recordsTotal / this.limitShow);
      this.dataEnd = dataApprovalNewSO.length;
      this.dataSalesOrder = dataApprovalNewSO
    },
  },
};
</script>

<style>
/* Efek indeterminate custom */
.is-indeterminate span.vs-checkbox--check {
  opacity: 0;
}
.is-indeterminate span.checkbox_x {
  background-color: rgba(var(--vs-primary), 1) !important;
  border-color: rgba(var(--vs-primary), 1) !important;
}
.is-indeterminate span.checkbox_x::after {
  content: "";
  position: absolute;
  left: 40%;
  top: 25%;
  width: 3px;
  height: 50%;
  background-color: white;
  border-radius: 2px;
}
/*end Efek indeterminate custom */

.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}
</style>
